// series — lista serii, widok płaski, strona serii, podgląd i odtwarzacz (sesja 09).
// Klucze lustrzane z ../en/series.ts; parytet pilnuje `locales-parity.test.ts`, bo
// `check_locale_keys.py` tego namespace'u nie widzi (KEY_RX).
// Liczebniki: rodzina `_one/_few/_many` wybierana przez `pluralForm(locale, n)`.
export const series = {
  title: 'Edity',
  new: 'Nowa seria', select: 'Zaznacz serię', selected: 'zaznaczone', selectedOf: 'Zaznaczone: {n} z {total}',
  allReady: 'Zaznacz gotowe ({n})', selectReady: 'Zaznacz gotowe ({n})',
  clear: 'Wyczyść', more: 'Załaduj więcej', shown: 'Pokazano {n} z {total}',
  // nagłówek nad pełną listą: „12 serii · 71 editów" (zamiast intro na każdej wizycie)
  seriesCount_one: '{n} seria', seriesCount_few: '{n} serie', seriesCount_many: '{n} serii',
  editsCount_one: '{n} edit', editsCount_few: '{n} edity', editsCount_many: '{n} editów',
  // tożsamość serii pod nazwą (decyzja 4): identyfikator skrócony, mono
  number: 'seria #{id}',
  remove: 'Usuń serię', removeSelected: 'Usuń zaznaczone', removeTitle: 'Usunąć wybrane serie?',
  removeBody: 'Serie: {series}. Pliki MP4: {files}. Rozmiar: {size}.',
  keep: 'Zostaw',
  actionError: 'Nie udało się wykonać tej czynności. Odśwież stan i spróbuj ponownie.',
  chunks: '{done} z {total} kawałków',
  thumbPending: 'Generuje miniaturę', thumbUnavailable: 'Miniatura niedostępna',
  preview: 'Podgląd editu {n}', position: 'edit {n} z {total}', previous: 'Poprzedni edit', next: 'Następny edit',
  play: 'Odtwórz', pause: 'Pauza', seek: 'Pozycja odtwarzania', volume: 'Głośność', mute: 'Wycisz', unmute: 'Włącz dźwięk',
  fullscreen: 'Pełny ekran', playing: 'gra',
  // podpowiedzi klawiszy w nakładce podglądu
  escClose: 'zamknij', arrowsNav: 'poprzedni / następny edit',
  // wiersze faktów w popupie podglądu (sesja 19): etykieta / wartość zamiast kropek
  previewFacts: { series: 'Seria', track: 'Utwór', style: 'Styl', packs: 'Paczki klipów', duration: 'Długość', size: 'Rozmiar' },
  music: 'Utwór', packs: 'Paczki klipów', style: 'Styl', status: 'Status', all: 'Wszystkie',
  // skróty statusu w widoku płaskim (liczby z `status_counts`)
  filterStatus: { done: 'Gotowe', rendering: 'W kolejce', failed: 'Błąd', queued: 'W kolejce' },
  moreFilters: 'Więcej filtrów', filtersCount: 'Filtry ({n})', removeFilter: 'Usuń filtr: {name}',
  fragment: 'Fragment', styles: 'Style i liczba editów', cost: 'Koszt', created: 'Utworzono', createdAt: 'utworzono {date}',
  gems: 'Tokeny: {n}', noResults: 'Nie ma editów z tymi filtrami.',
  errorBody: 'Twoje pliki i tokeny są bezpieczne. Sprawdź połączenie i spróbuj jeszcze raz.',
  resetFilters: 'Wyczyść filtry',
  variants: 'Zrób warianty z tych ustawień', retryFailed: 'Ponów nieudane ({n} × {cost} tokenów)',
  retryUnavailable: 'Nie zachowały się ustawienia tego editu. Utwórz nową serię w Generatorze.',
  priceLoading: 'Cennik się jeszcze ładuje - przycisk włączy się sam, gdy wróci odpowiedź.',
  // Paczka N2 (Z4): przy niewczytanym cenniku kafel ponowienia stoi nieaktywny, a obok
  // niego mała akcja ponownego odczytu `/api/render-config` - koszt musi być znany
  // PRZED obciążeniem, więc czekanie w nieskończoność nie jest odpowiedzią.
  priceRefresh: 'Odśwież cennik',
  // Powody, dla których ZIP-a nie da się złożyć (Z1). Docierają do czytnika ekranu
  // przez `aria-describedby` i do myszy przez `title`; widocznym nośnikiem stanu
  // zostaje sam nieaktywny przycisk (zasada 8).
  // Seria w toku z gotową częścią (Z2): ZIP bierze to, co JUŻ jest, a liczba w etykiecie
  // mówi ile - zamiast zdania o tym, czego w archiwum nie ma.
  zipPartial: 'Pobierz gotowe · {n}',
  // Powód, dla którego pobranie zaznaczonych editów jest nieaktywne, gdy nic nie wybrano.
  zipPickNone: 'Zaznacz edity, które mają wejść do pobrania.',
  // Fakt z ledgera przy nieudanym edicie (Z0, inwariant 5 z CLAUDE.md). Nazwa dla
  // czytnika stoi przy liczbie „+{n} tokenów"; dopóki ledger nie potwierdzi zwrotu,
  // kafel niesie pigułkę stanu rozliczenia zamiast liczby.
  refundBack: 'Zwrot tokenów',
  refundPending: 'rozliczenie w toku',
  zipPreparing: 'Przygotowujemy ZIP', zipDownloading: 'Pobieranie ZIP', zipHanded: 'Pobieranie przekazane przeglądarce.',
  zipCancel: 'Przerwij pobieranie', zipDone: 'ZIP zapisany', unknownSize: 'rozmiar nieznany',
  queuedAfter: 'W kolejce po edicie {n}', queuedSlot: 'Czeka na wolny slot',
  meanTime: 'Średni czas gotowego editu: {n} s', back: 'Wróć do Editów',
  hook: 'Hook',
  zipShort: 'Pobierz ZIP ({n})', zipWithSize: 'Pobierz ZIP ({n}) · {size}',
  zipFiles_one: 'Pobierz ZIP · {n} plik · {size}', zipFiles_few: 'Pobierz ZIP · {n} pliki · {size}', zipFiles_many: 'Pobierz ZIP · {n} plików · {size}',
  // Strona serii: ten sam krótki fakt dla każdej liczby.
  readyOf_one: '{done} z {total} gotowych', readyOf_few: '{done} z {total} gotowych', readyOf_many: '{done} z {total} gotowych',
  gemsFormula_one: '{n} edit × {cost} = {total}', gemsFormula_few: '{n} edity × {cost} = {total}', gemsFormula_many: '{n} editów × {cost} = {total}',
  gemsWord_one: '{n} token', gemsWord_few: '{n} tokeny', gemsWord_many: '{n} tokenów',
  editsHeading: 'Edity', editsOrder: 'kolejność z serii',
  retryFailed_one: 'Ponów nieudane ({n} × {cost} token)',
  retryFailed_few: 'Ponów nieudane ({n} × {cost} tokeny)',
  retryFailed_many: 'Ponów nieudane ({n} × {cost} tokenów)',
  // ── sesja 30 (język minimal): ekran startowy „Edity" ─────────────────────────
  // Teksty z `design/claude-design-wyniki/30-minimal-powloka-edity/MAPA.md` (artboardy
  // 04, 05a/b, 06a–c, 07, 08a, 09a–c). Stare klucze tej samej rzeczy zostają dopóty,
  // dopóki wołają je ekrany jeszcze nieprzepięte na język minimal (strona serii, edit).
  downloadAll: 'Pobierz wszystkie',
  sameSettings: 'Te same ustawienia',
  // Pusty stan nowego konta (dawne pierwsze uruchomienie Pulpitu, artboard 05a).
  firstRunTitle: 'Zacznij od utworu',
  firstRunCta: 'Wgraj utwór',
  errorTitle: 'Nie udało się wczytać serii.',
  selectMode: 'Zaznacz',
  selectedCount: 'Zaznaczone: {n}',
  selectedCountMax: 'Zaznaczone: {n} / {max}',
  // Powód, dla którego kolejny kafel się nie zaznacza (reguła 19). Osobny od
  // `selectionLimit`, bo tamten mówi o SERIACH, a tu zaznacza się pojedyncze edity.
  // Liczba nie rządzi tu rzeczownikiem świadomie (`locales-parity`): {max} to stała
  // `SELECTION_LIMIT`, więc rodzina liczebnika byłaby trzema kopiami jednego zdania.
  // Zaznaczone edity idą jako osobne pliki MP4 (backend nie zna ZIP-a z dowolnego
  // zbioru editów), więc etykieta mówi o plikach, nie o archiwum.
  downloadSelected_one: 'Pobierz {n} plik · {size}',
  downloadSelected_few: 'Pobierz {n} pliki · {size}',
  downloadSelected_many: 'Pobierz {n} plików · {size}',
  downloadFailedToast: 'Nie udało się pobrać wszystkich plików.',
  selectEdit: 'Zaznacz edit {n} z serii {series}',
  openEdit: 'Otwórz edit',
  removeOneTitle: 'Usunąć serię?',
  // R5 (zasada 8 + reguła 34): zostaje JEDNO zdanie decyzji. Obietnica o walucie
  // wyleciała z okna — zwrot i jego brak żyją w ledgerze i w saldzie, nie w oknie.
  removedToast: 'Seria usunięta.',
  // ── R5 (reguła 31): data wygenerowania ─────────────────────────────────────
  // Dwa słowa i jedno miejsce na godzinę; resztę postaci („18 wrz, 18:00”,
  // „18.09.2025”) składa `locales/generatedAt.ts` z `Intl`, więc nie ma ich tutaj.
  dateToday: 'dziś {time}',
  dateYesterday: 'wczoraj {time}',
  // Wiersz serii i linia stanu strony serii: licznik, kropka, data.
  readyWithDate: '{ready} · {date}',
  removeFailedToast: 'Nie udało się usunąć serii.',
  // {gems} przychodzi już odmienione (`gemWord`), bo w jednym zdaniu stoją DWIE liczby
  // o różnych rodzajach: liczba editów wybiera rodzinę klucza, liczba gemów swoją formę.
  retriedToast_one: 'Ponowiono {n} edit · -{gems}',
  retriedToast_few: 'Ponowiono {n} edity · -{gems}',
  retriedToast_many: 'Ponowiono {n} editów · -{gems}',
  retryFailedToast: 'Nie udało się ponowić editów.',
}
